import { render, staticRenderFns } from "./PaginatedSelect.vue?vue&type=template&id=159a1f13"
import script from "./PaginatedSelect.vue?vue&type=script&lang=ts"
export * from "./PaginatedSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports